import React from 'react';
import { DynamicContentList } from '../features/dynamicContent/components/DynamicContentList'; // ודאי שהנתיב נכון בהתאם למבנה התיקיות שלך

const DynamicContentPage = () => {
  return (
    <div>
      <DynamicContentList />
    </div>
  );
};

export default DynamicContentPage;
